module.exports = __webpack_public_path__ + "img/correct.2ba36138.svg";